import { BIM360Issue } from "./BIM360Issue";
import { AutodeskDmFolder } from "./AutodeskDmFolder";

export abstract class BIM360Project {
  public id: string = "";
  public name: string = "";
  public url: string = "";
  public hubId: string = "";
  public issueContainerId: string = "";
  public locationContainerId: string = "";

  public abstract getIssues(): Promise<BIM360Issue[]>;
  public abstract getFolders(): Promise<AutodeskDmFolder[]>;
}
